<template>
  <select
    class="component_normal_input languageSelector"
    v-model="storeLanguage"
    v-if="!isMobile"
  >
    <option v-for="language in languages" :key="language" :value="language">{{
      $tc(`msg.${language}`, 1)
    }}</option>
  </select>

  <ul class="language_selector_mobile" v-else>
    <li
      v-for="language in languages"
      :key="language"
      :value="language"
      @click="changeLanguage(language)"
      :class="storeLanguage == language ? 'router-link-active' : ''"
    >
      {{ $tc(`msg.${language}`, 1) }}
    </li>
  </ul>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  mounted() {
    this.languageSelectedOnPage = this.languageSelected;
    this.checkIfMobile();
  },
  created() {
    window.addEventListener("resize", this.checkIfMobile);
  },
  data: () => ({
    languageSelectedOnPage: "",
    isMobile: ""
  }),
  methods: {
    changeLanguage(lang) {
      this.languageSelectedOnPage = lang;
      this.$store.dispatch("setLanguageSelected", lang);
    },

    checkIfMobile() {
      let w = window,
        x = w.innerWidth;
      if (x > 1200) {
        this.isMobile = false;
      } else {
        this.isMobile = true;
      }
    }
  },
  computed: {
    ...mapGetters(["languages", "languageSelected"]),
    storeLanguage: {
      get() {
        return this.languageSelectedOnPage;
      },
      set(value) {
        this.changeLanguage(value);
      }
    }
  }
};
</script>

<style scoped lang="scss">
li {
  display: inline;
  margin-right: 12px;
  color: white;
}

select {
  font-size: 18px;
  padding: 0 12px;
  background-color: transparent;
  color: white;
}
option {
  background-color: transparent;
}
</style>



// WEBPACK FOOTER //
// src/components/public/BaseLanguageBar.vue